import { render } from "./BounceBallLoader.vue?vue&type=template&id=ef24b180&scoped=true"
const script = {}

import "./BounceBallLoader.vue?vue&type=style&index=0&id=ef24b180&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef24b180"]])

export default __exports__